<div
  class="switch"
  [ngClass]="{ 'switch--disabled': disabled }"
>
  <input
    class="switch__control"
    type="checkbox"
    [id]="name"
    [name]="name"
    [disabled]="disabled"
    [(ngModel)]="value"
  />
  <label
    class="switch__label"
    [for]="name"
  ></label>
  <label
    class="switch__text"
    [for]="name"
  >{{ label }}</label>
</div>
